var _path, _rect, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _ellipse;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyStateGeneric = function SvgEmptyStateGeneric(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 145,
    viewBox: "0 0 176 145",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0488 8.76025C-5.9352 24.4333 -1.4213 61.507 4.24212 78.0843C12.2376 97.6754 28.4006 119.048 47.7172 127.314C70.0213 136.859 103.502 134.22 121.675 131.333C137.483 128.821 167.749 118.774 173.145 109.23C178.541 99.6852 177.959 81.0985 156.472 72.5587C138.776 65.5259 125.989 39.4031 111.681 22.8266C97.3718 6.25018 57.0287 -10.8311 22.0488 8.76025Z",
    fill: "#EBEFF3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 19.5,
    width: 148,
    height: 101,
    rx: 2.5,
    fill: "white",
    stroke: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161 26L14 26",
    stroke: "#E4E4E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.687 66.5997C116.598 54.0459 102.285 48.0349 89.8275 53.1948C79.3315 57.5035 73.3943 68.3551 74.8256 79.1535L52.6141 88.2497C49.4865 89.5264 48.0022 93.0904 49.2745 96.2288C50.5467 99.3673 54.0984 100.857 57.2261 99.5801L79.4375 90.4839C85.9048 99.3141 97.7791 102.985 108.381 98.6226C120.839 93.4627 126.829 79.1535 121.687 66.5997Z",
    fill: "#9DCEFE",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.707 63.7609C109.58 51.2866 95.3612 45.3137 82.8869 50.4409C70.4126 55.5152 64.4397 69.7866 69.5668 82.208C74.6411 94.6824 88.9126 100.655 101.334 95.5281C113.808 90.4538 119.781 76.1823 114.707 63.7609ZM110.795 80.7809C108.734 85.7495 104.823 89.6081 99.8012 91.6695C97.3169 92.6738 94.7797 93.2024 92.1369 93.2024C83.8912 93.2024 76.544 88.2866 73.4254 80.6223C69.1968 70.3152 74.1654 58.4752 84.4726 54.2994C86.904 53.2951 89.494 52.7666 92.1369 52.7666C100.383 52.7666 107.73 57.6823 110.848 65.3466C112.857 70.3152 112.857 75.8123 110.795 80.7809Z",
    fill: "#9DCEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7967 92.6105C48.5853 92.7162 48.321 92.769 48.0567 92.769C47.2638 92.769 46.5767 92.2933 46.3124 91.6062C46.0481 90.9719 46.2067 90.4433 46.3124 90.1262C46.4181 89.8619 46.7353 89.3862 47.3695 89.1219L68.8824 80.2947C68.4596 78.9205 68.1424 77.5462 67.9839 76.1719L45.7838 85.2633C42.6652 86.5319 41.1852 90.0733 42.4538 93.1919C43.7224 96.3105 47.2638 97.7905 50.3824 96.5219L72.5296 87.4833C71.6839 86.3733 70.9439 85.1576 70.3096 83.889L48.7967 92.6105Z",
    fill: "#9DCEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.875 54.9549C94.1492 55.3819 90.5835 56.7163 86.3046 59.7052C81.9709 62.7475 79.2829 66.1634 78.7343 66.5903C78.2955 66.8572 80.1058 63.1211 85.0429 58.9579C89.4864 55.2218 93.5458 54.528 93.875 54.9549Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 23,
    r: 1,
    fill: "#CE2030"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 23,
    r: 1,
    fill: "#64C67C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 23,
    r: 1,
    fill: "#FFD57C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88,
    cy: 142.5,
    rx: 53,
    ry: 2.5,
    fill: "#EBEFF3"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyStateGeneric, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-state-generic.feea388e.svg";
export { ForwardRef as ReactComponent };